<template>
    <app-page-content>
        <app-sub-title text="Indicadores de adopción" />
        <app-clients-select-input
            v-if="!haveAClient"
            v-model="clientId"
        />
        <app-dashboard-adoption v-if="clientId"
            :client-id="clientId"
        />
    </app-page-content>
</template>
<script>
import DashboardAdoption from './DashboardAdoption/DashboardAdoption.vue';
export default {
    components: {
        appDashboardAdoption: DashboardAdoption
    },
    data(){
        return{
            clientId: '',
            haveAClient: false
        }
    },
    created(){
        this.haveAClient = !!this.client ? true: false;
        if(this.haveAClient){
            this.clientId = this.client.id;
        }
    }
}
</script>